module.exports = __webpack_public_path__ + "img/bx_bxs-chat.d1b100f6.svg";